export default __webpack_public_path__ + "static/ReadersChoiceTeamPic_2018-c6562ad741aa53e51dca84f3e1b77393.jpg";